import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import DoctorDetailComponent from 'src/components/views/Doctor/DoctorDetailPage';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';

const mapStateToProps = ({
  userState: { isAgent, userInfo, isDomestic },
  drugStoreState: { drugStores },
  selectDoctorState: { detailType, doctorInfo },
  rechargeState: { options },
}: IStoreState) => ({
  isAgent,
  userInfo,
  isDomestic,
  drugStores,
  detailType,
  doctorInfo,
  rechargeList: options,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DoctorDetailComponent);



// WEBPACK FOOTER //
// ./src/containers/DoctorDetail.ts